import React from 'react';
import { Button, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDevice } from '../../hooks/useDevice';

interface BackButtonProps {
  onClick?: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceType = useDevice();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  // На мобильных устройствах используем ActionIcon
  if (deviceType === 'mobile') {
    return (
      <ActionIcon variant="light" size="sm" onClick={handleClick}>
        <IconArrowLeft size={16} />
      </ActionIcon>
    );
  }

  // На планшетах и десктопе используем Button
  return (
    <Button
      variant="light"
      leftSection={<IconArrowLeft size={16} />}
      size="sm"
      onClick={handleClick}
    >
      {t('profile.back')}
    </Button>
  );
};
